<template>
  <div>
    <v-toolbar flat color="white" class= "pt-3">
      <h2 class="dark-grey--text px-2">Frontend Route: {{routeDetail.name}}</h2>
      <v-spacer></v-spacer>
      <v-btn round color="primary" @click="saveChanges">Save Changes</v-btn>
    </v-toolbar>
    <v-toolbar flat color="white">
      <v-tabs  div="tabs">
        <v-tabs-slider color="primary"></v-tabs-slider>
        <v-tab
          href="#"
          v-model="tabs"
          v-for="tab in tabs"
          :key="tab.name"
          @click="setActiveTabName(tab.name)"
        >{{tab.displayName}}</v-tab>
      </v-tabs>
    </v-toolbar>
    <div v-if="displayContents('routeBackend')">
         <v-data-table
        :headers="headers"
        class="elevation-1"
        :items="allBackendRoutes"
        v-model="backendRoutes"
        item-key="id"
        align-center
        select-all
      >
        <template v-slot:items="props">
          <!-- <td class="text-xs-center">
            <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          </td> -->
          <td>
          <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
        </td>
          <td class="text-xs-center">{{props.item.name}}</td>
           <td class="text-xs-center">{{props.item.urlExtension}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>

    </div>
    <div v-if="displayContents('tabs')">
         <v-data-table
        :headers="tabHeaders"
        class="elevation-1"
        :items="allBackendRoutes"
        v-model="backendRoutes"
        item-key="id"
        align-center
        select-all
      >
        <template v-slot:items="props">
          <!-- <td class="text-xs-center">
            <v-icon small @click="deleteItem(props.item)">delete</v-icon>
          </td> -->
          <td>
          <v-checkbox id="checkBoxId" v-model="props.selected" primary hide-details></v-checkbox>
        </td>
          <td class="text-xs-center">{{props.item.name}}</td>
           <td class="text-xs-center">{{props.item.urlExtension}}</td>
        </template>
        <template
          v-slot:pageText="props"
        >Records {{ props.pageStart }} - {{ props.pageStop }} of {{ props.itemsLength }}</template>
      </v-data-table>

    </div>
  </div>
</template>

<script>
import Api from "@/services/Api";

export default {
  data() {
    return {
        routeDetail: null,
        backendRoutes: [],
        allBackendRoutes: [],
        initialBackendRoutes:[],
        foreignKey:[],
      tabs: [
        { name: "routeBackend", displayName: "Backend Routes" }
      ],
      headers: [
        //         {
        //   text: "Action",
        //   align: "center"
        // },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "URL Extension",
          align: "center",
          value: "urlExtension"
        }],
      tabHeaders: [
        //         {
        //   text: "Action",
        //   align: "center"
        // },
        {
          text: "Name",
          align: "center",
          value: "name"
        },
        {
          text: "Display Name",
          align: "center",
          value: "displayName"
        }]
    };
  },

  created() {
    this.initialize();
    this.setActiveTabName('routeBackend')
  },
  async mounted() {
      this.setActiveTabName('routeBackend')
  },

  methods: {
    fetchBackend(){
      Api()
      .get('/backendRoute')
      .then(response=>{
        this.allBackendRoutes=response.data
      })
    },
    fetchRouteInfo(){
        this.backendRoutes=[]
        this.initialBackendRoutes=[]
        this.foreignKey=[]
      Api()
      .get('/frontendRoute/'+this.$route.params.frontendRouteId)
      .then(response=>{
        this.routeDetail=response.data
        let routeFrontendRouteBackends= response.data.routeFrontendRouteBackends
        for (let i=0;i< routeFrontendRouteBackends.length;i++){
            if(!routeFrontendRouteBackends[i].isDeleted){
                this.backendRoutes.push(routeFrontendRouteBackends[i].routeBackend)
                this.initialBackendRoutes.push(routeFrontendRouteBackends[i].routeBackend)
                this.foreignKey.push({id: routeFrontendRouteBackends[i].id, backendRouteId: routeFrontendRouteBackends[i].routeBackend.id})
            }
        }
      })
    },
    fetchTabs(){
      Api()
      .get('/tabs')
      .then(response=>{
        console.log(response.data)
      })
    },
    displayContents(name) {
      return this.activeTabName === name;
    },
    setActiveTabName(name) {
      this.activeTabName = name;
    },

    initialize() {
        this.fetchRouteInfo();
        this.fetchBackend();
    },
    async saveChanges(){
        for(let i=0;i<this.backendRoutes.length;i++){
            if(this.initialBackendRoutes.indexOf(this.backendRoutes[i])===-1){
                await Api()
                .post('/routeFrontendRouteBackend',{
                    routeFrontendId: this.$route.params.frontendRouteId,
                    routeBackendId: this.backendRoutes[i].id,
                    isActive: true,
                    isDeleted: false
                })
            }
        }
        for(let x =0; x<this.initialBackendRoutes.length;x++){
            if(this.backendRoutes.indexOf(this.initialBackendRoutes[x])===-1){
                let backendRouteId=this.initialBackendRoutes[x].id
                let foreignKeyId = this.foreignKey.filter(function(el){
                    return el.backendRouteId===backendRouteId
                })
                await Api()
                .put('/routeFrontendRouteBackend/'+foreignKeyId[0].id,{
                    isActive: false,
                    isDeleted: true
                })
            }
        }
        this.fetchRouteInfo()
    }
  }
};
</script>
<style>
.Planned {
  border-left: solid #d61212;
}
.Ongoing {
  border-left: 4px solid #eb780c;
}
.Complete {
  border-left: 4px solid #5eb110;
}
.Live {
  border-left: 4px solid #5eb110;
}
</style>
